<template>
  <div class="star-rating">
    <div
      v-for="index in 5"
      :key="index"
      class="star"
    >
      <div class="star-base">
        <i class="ri-star-fill"></i>
      </div>
      <div
        class="star-overlay"
        :style="{ width: getStarFill(index) + '%' }"
      > <i class="ri-star-fill"></i></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  rating: {
    type: Number,
    required: true,
    default: 0,
  },
});

const getStarFill = (index) => {
  const diff = props.rating - (index - 1);
  if (diff >= 1) return 100;
  if (diff <= 0) return 0;
  return +(diff * 100).toFixed(2); // làm tròn đến 2 chữ số sau dấu phẩy
};
</script>

<style scoped>
.star-rating {
  display: flex;
  justify-content: center;
  gap: 3px;
  font-size: 45px;
  line-height: 1;
}

.star {
  position: relative;
  width: 1em;
  height: 1em;
  overflow: hidden;
}

.star-base {
  color: #dfdfdf; /* màu xám nhạt cho sao chưa được đánh */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.star-overlay {
  color: #FADD75;
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  width: 0%;
}
</style>